import { useEffect, useRef, useState } from 'react'

const COMPACT_OFF_PX = 16

export function useScrollCompact(headerRef?: React.RefObject<HTMLElement | null>): boolean {
	const [isCompact, setIsCompact] = useState(false)
	// Cache the measured threshold so we don't re-query the DOM on every scroll event.
	const compactOnPxRef = useRef<number>(120)

	useEffect(() => {
		// Re-measure whenever the header resizes (e.g. async schedule pill or sign-in appears).
		let ro: ResizeObserver | undefined
		if (headerRef?.current && typeof ResizeObserver !== 'undefined') {
			const measure = () => {
				const h = headerRef.current?.getBoundingClientRect().height ?? 0
				if (h > 0) compactOnPxRef.current = h
			}
			measure()
			ro = new ResizeObserver(measure)
			ro.observe(headerRef.current)
		}

		function handleScroll() {
			const y = window.scrollY
			setIsCompact((prev) => {
				if (!prev && y >= compactOnPxRef.current) return true
				if (prev && y <= COMPACT_OFF_PX) return false
				return prev
			})
		}

		window.addEventListener('scroll', handleScroll, { passive: true })
		// Sync on mount in case the page is already scrolled (e.g. back navigation)
		handleScroll()
		return () => {
			window.removeEventListener('scroll', handleScroll)
			ro?.disconnect()
		}
	}, [headerRef])

	return isCompact
}
